import { GenIcon, IconTree, IconType } from 'react-icons';

export const createIconFromSvg =
  (iconProps: IconTree): IconType =>
  (props) =>
    GenIcon(iconProps)(props);
